import type { FaireProductEntity } from "../../entity_types/product";

export const p_hj4p8bsagp: FaireProductEntity = {
  token: "p_hj4p8bsagp",
  type: "product",
  name: "rocky's matcha & retaW \"Green Magic\" Car Tag",
  brandToken: "b_jkddc7grcu",
  brandName: "rocky's matcha",
  imageUrl: "https://cdn.faire.com/fastly/45dbde39b9adc9815d288520939b3dae8fa9cf6a11f1adce2104fe05b03ea821.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3e8b7801222e54d75af2f3502a15c0a19c4958000d9caac9da8718382be3213a.jpeg",
    "https://cdn.faire.com/fastly/ff5883122b55303bbf73514678d698057fc2dd4a115cc354892a7c1fe72d7c89.jpeg",
    "https://cdn.faire.com/fastly/fa421576841f26835793ced65abf83b28985e263b5b53a3cdd566a83348cc35a.jpeg",
    "https://cdn.faire.com/fastly/a12e19d9733f808658d96f3c884f17e3aa15134d79564499355e06599cf666cf.jpeg",
    "https://cdn.faire.com/fastly/2bb0083be3e16f1fa9c66a73ebab4f6479cf62a6757284c6001462411a4611da.jpeg"
  ],
  priceDollars: 12,
  description: "rocky's matcha & retaW \"Green Magic\" Car Tag\n\nrocky's matcha has collaborated with renowned Japanese fragrance brand, retaW, to create a unique car tag with a custom scent, \"Green Magic\". Developed in partnership with retaW, this scent incorporates notes of Green Tea, Milk, Matcha, and Vanilla. The car tag also features artwork by long-time collaborator Ryuto Miyake.\n\n• Size: 82mm x 110mm\n• Weight: 11.5 grams",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:22.513Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
